import * as React from 'react';
import GenericHoc from 'components/common/generic-hoc';
import { HocOptions } from 'components/common/generic-hoc.types';
import { StylesProps, ThemeType } from 'theme/jss-types';
import { commonStyleSheet } from 'library/common-styles';
import {
    Col,
    FormInstance,
    Form,
} from 'antd';
import { formFields } from 'components/create-consignment/create-modal.constants';
import { getEnvelopeFieldFromMapping } from '../../generic-sub-layout-renderer';
import { uniqueId } from 'lodash';

const styles = (theme: ThemeType) => ({
    referenceItem: {
        display: 'flex',
        flexDirection: 'column',
    },
    referenceTitle: {
        color: '#333333',
        fontFamily: 'Open Sans',
        fontSize: 12,
        letterSpacing: 0,
        width: '100%',
        marginBottom: 4,
    },
    contentType: {
        ...commonStyleSheet(theme).flexRow,
        justifyContent: 'space-between',
        '& .ant-form-item': {
            marginBottom: 0,
        },
    },
});

interface IProps extends StylesProps<ReturnType<typeof styles>>, ReturnType<typeof mapStateToProps> {
    form: FormInstance;
    params: any;
}

const EnvelopeDetailsField = (props: IProps) => {
    const {
        form,
        params,
    } = props;

    const documentDetailsLayout = params?.subLayout?.envelope || [];

    const {
        ItemType,
    } = formFields;

    const itemType = Form.useWatch(ItemType.key, form);

    if (itemType !== 'envelope') {
        return null;
    }

    const envelopeDetailsForm = documentDetailsLayout.map(
        (fieldKey: any) => getEnvelopeFieldFromMapping(fieldKey, form, {
            ...params,
        }),
    );

    return (
        <>
            <div
                style={{
                    width: '100%',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '10px',
                }}
                key={uniqueId() + (+new Date())}
            >
                <Col span={24}>
                    {envelopeDetailsForm}
                </Col>
            </div>
        </>
    );
};

const mapStateToProps = () => ({});

const hocConfig: HocOptions = {
    connectRedux: {
        useRedux: true,
        mapStateToProps,
    },
    connectJss: {
        useJss: true,
        styleSheet: styles,
    },
};

export default GenericHoc(hocConfig)(EnvelopeDetailsField);
